import { Notifier, Option, Terminable, Terminator } from "@opendaw/lib-std";
import { AudioBusBoxAdapter } from "./AudioBusBoxAdapter";
export class AudioUnitOutput {
    #pointerField;
    #boxAdapters;
    #terminator;
    #busChangeNotifier;
    #subscription = Terminable.Empty;
    constructor(pointerField, boxAdapters) {
        this.#pointerField = pointerField;
        this.#boxAdapters = boxAdapters;
        this.#terminator = new Terminator();
        this.#busChangeNotifier = this.#terminator.own(new Notifier());
        this.#terminator.own(pointerField.catchupAndSubscribe(() => {
            this.#subscription.terminate();
            this.#subscription = this.adapter.match({
                none: () => {
                    this.#busChangeNotifier.notify(Option.None);
                    return Terminable.Empty;
                },
                some: adapter => adapter.catchupAndSubscribe(adapter => this.#busChangeNotifier.notify(Option.wrap(adapter)))
            });
        }));
    }
    subscribe(observer) {
        return this.#busChangeNotifier.subscribe(observer);
    }
    catchupAndSubscribe(observer) {
        observer(this.adapter);
        return this.subscribe(observer);
    }
    get adapter() {
        return this.#pointerField.targetVertex
            .flatMap(target => Option.wrap(target.box.accept({
            visitAudioBusBox: (box) => this.#boxAdapters.adapterFor(box, AudioBusBoxAdapter)
        })));
    }
    terminate() {
        this.#terminator.terminate();
        this.#subscription.terminate();
    }
}
